import {
  Box,
  FieldLabel,
  Flex,
  Form,
  SubmitButton,
  Text,
  TextInputField,
} from '@/components';
import { FundBusinessUpdateFormSchema } from '@/features/project/projects/detail/fund-bussiness/_model/fund-business';
import type { FundBusinessFormValues } from '@/features/project/projects/detail/fund-bussiness/_model/fund-business';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { FormProvider, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FundBusinessTitleField } from '../fields/FundBusinessTitleField';
import { FundBusinessAmountFields } from '../fields/fund-business-amount-fields/FundBusinessAmountFields';

type Props = {
  initialValues?: FundBusinessFormValues;
  onSubmit: (values: FundBusinessFormValues) => void;
  fiscalYear: number;
};

export const OthersForm: FC<Props> = ({
  initialValues,
  onSubmit,
  fiscalYear,
}) => {
  const { t } = useTranslation();

  const formMethods = useForm<FundBusinessFormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(FundBusinessUpdateFormSchema),
  });

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isDirty, errors, isSubmitSuccessful },
  } = formMethods;

  const { fields } = useFieldArray({ name: 'performances', control });

  return (
    <FormProvider {...formMethods}>
      <Form
        leavePageAlertCondition={{
          isDirty,
          isSubmitting,
          isSubmitSuccessful,
        }}
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
      >
        <FundBusinessTitleField />

        <Form.Item label={<FieldLabel text={t('item-name')} />}>
          <Flex vertical gap={8}>
            {fields.map((field, index) => {
              return (
                <Flex key={field.id} align="center" gap={8}>
                  <Box flex={1}>
                    <Text text={index + 1} weight="regular" />
                  </Box>
                  <Box flex={4}>
                    <TextInputField
                      control={control}
                      name={`performances.${index}.title`}
                      autocompleteKey="fundBusiness.performance.title"
                      errors={errors}
                      marginBottom={0}
                    />
                  </Box>
                </Flex>
              );
            })}
          </Flex>
        </Form.Item>
        <FundBusinessAmountFields
          fiscalYear={fiscalYear}
          fields={fields}
          isOthers
        />
        <SubmitButton
          text={t('save')}
          disabled={!isDirty}
          loading={isSubmitting}
        />
      </Form>
    </FormProvider>
  );
};
